/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Field_Size_RunInputs */

const en_field_size_run = /** @type {(inputs: Field_Size_RunInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Size run`)
};

/**
* | output |
* | --- |
* | "Size run" |
*
* @param {Field_Size_RunInputs} inputs
* @param {{ locale?: "en" }} options
* @returns {LocalizedString}
*/
export const field_size_run = /** @type {((inputs?: Field_Size_RunInputs, options?: { locale?: "en" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Field_Size_RunInputs, { locale?: "en" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return en_field_size_run(inputs)
});